export enum MenuOptionValue {
    AgentConfiguration = 'agentConfiguration',
    RegionalKnowledgeFiles = 'regionalKnowledgeFiles',
    AvatarConfiguration = 'avatarConfiguration',
    GeneralPredefinedPrompts = 'generalPredefinedPrompts',
    PredefinedPromptsByRole = 'predefinedPromptsByRole',
}
